import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { DETAIL_MESSAGE, SEVERITY, SUMMARY_MESSAGE } from "@shared/constants/message-service.constants";
import { Guid } from "guid-typescript";
import { MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-message-service",
  standalone: true,
  imports: [ToastModule, ChipModule, ButtonModule],
  providers: [MessageService],
  templateUrl: "./message-service.component.html",
  styleUrl: "./message-service.component.scss",
})
export class MessageServiceComponent implements OnChanges {
  @Input() id: Guid = Guid.create();
  @Input() summaryMessage!: string;
  @Input() detailMessage!: string;
  @Input() severity!: string;
  @Input() shouldRedirect = false;
  @Output() toastClosed: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly messageService: MessageService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes[SEVERITY]) {
      this.severity = changes[SEVERITY].currentValue ?? this.severity;
    }
    if (changes[SUMMARY_MESSAGE]) {
      this.summaryMessage = changes[SUMMARY_MESSAGE].currentValue ?? this.summaryMessage;
    }
    if (changes[DETAIL_MESSAGE]) {
      this.detailMessage = changes[DETAIL_MESSAGE].currentValue ?? this.detailMessage;
    }
    this.messageService.add({
      severity: this.severity,
      summary: this.summaryMessage,
      detail: this.detailMessage,
    });
  }

  closeToast() {
    this.messageService.clear();
  }

  onToastClose() {
    if (this.shouldRedirect) {
      this.toastClosed.emit();
    }
  }

  get getBgColorClass(): string {
    switch (this.severity) {
      case "success":
        return "bg-success";
      case "info":
        return "bg-info";
      case "warn":
        return "bg-warn";
      case "error":
        return "bg-error";
      default:
        return "";
    }
  }

  get getBgGradientClass(): string {
    switch (this.severity) {
      case "success":
        return "bg-success-gradient";
      case "info":
        return "bg-info-gradient";
      case "warn":
        return "bg-warn-gradient";
      case "error":
        return "bg-error-gradient";
      default:
        return "";
    }
  }
}
